import { render, staticRenderFns } from "./FeedProductSite.vue?vue&type=template&id=1d786161&"
import script from "./FeedProductSite.vue?vue&type=script&lang=ts&"
export * from "./FeedProductSite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports